export const creatFetchSocialInvitation = (httpClient: typeof fetch) => (customerId: string) =>
  httpClient(`/console/api/v1/social/invite_programs?customer_id=${customerId}`).then((response) => response.json()) as Promise<SocialInvitation>;

export interface SocialInvitationItem {
  url: string;
  text?: string;
}

export interface SocialInvitation {
  cloudinary: SocialInvitationItem;
  twitter: SocialInvitationItem;
  facebook: SocialInvitationItem;
}
